import React, { useState } from 'react';
import { Box, Container } from '@mui/material';
import MUITypography from '../../Components/MUITypography';
import Rating from '@mui/material/Rating';
import { align_center } from '../../Styles/VMStyles';

const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.venuemanager.app&hl=en_IN';

const VMRateUs = () => {
  const [rating, setRating] = useState(0); // initial rating 0

  const handleRatingChange = (event, newValue) => {
    if (!newValue) return;
    setRating(newValue);
    window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Container maxWidth="sm">
      {/* Heading */}
      <MUITypography
        align="center"
        gutterBottom
        sx={{ mt:3,fontWeight: 700, ...align_center, marginBottom: 5 }}
      >
        Rate Us
      </MUITypography>

      {/* Banner Image */}
      <Box sx={{ ...align_center, mb: 4 }}>
        <Box
          component="img"
          src={'/static/vm-rate-us-banner.svg'}
          alt="Rate Us Banner"
          sx={{ width: '100%', maxHeight: 250, objectFit: 'contain' }}
        />
      </Box>

      {/* Rating Question */}
      <MUITypography
        align="center"
        gutterBottom
        sx={{ fontWeight: 600, mb: 2, ...align_center }}
      >
        How would you rate this application?
      </MUITypography>

      {/* Interactive 5-Star Rating */}
      <Box sx={{ ...align_center }}>
        <Rating
          name="user-rating"
          value={rating}
          size="large"
          onChange={handleRatingChange}
        />
      </Box>
    </Container>
  );
};

export default VMRateUs;
